import en from './en.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: en,
  ru: ru,
  zh: zh,
};
